export enum PostStatus {
  /** DRAFT - Post not available, because the author has not published it yet */
  DRAFT = 'draft',
  /** PUBLISHED - Post available */
  PUBLISHED = 'published',
}
